// src/services/assetService.js
//
// Wraps /api/assets/* backend calls.

import { api } from './api';

export const assetService = {
  getAssets: (status, category, search) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (category) params.append('category', category);
    if (search) params.append('search', search);
    const qs = params.toString();
    return api.get('/api/assets/' + (qs ? '?' + qs : ''));
  },

  getAsset: (assetId) =>
    api.get('/api/assets/' + assetId),

  createAsset: (data) =>
    api.post('/api/assets/', data),

  updateAsset: (assetId, data) =>
    api.put('/api/assets/' + assetId, data),

  assignAsset: (assetId, data) =>
    api.post('/api/assets/' + assetId + '/assign', data),

  returnAsset: (assetId, data) =>
    api.post('/api/assets/' + assetId + '/return', data),

  transferAsset: (assetId, data) =>
    api.post('/api/assets/' + assetId + '/transfer', data),

  logMaintenance: (assetId, data) =>
    api.post('/api/assets/' + assetId + '/maintenance', data),

  completeMaintenance: (assetId) =>
    api.put('/api/assets/' + assetId + '/maintenance/complete', {}),

  disposeAsset: (assetId, data) =>
    api.put('/api/assets/' + assetId + '/dispose', data),

  getWarrantyExpiring: (days) =>
    api.get('/api/assets/warranty-expiring?days=' + (days || 30)),
};